import { styled } from "@mui/system";
import React, { useEffect, useState } from "react";
import useStyles from "../../styles/drawer";
import { HiLockOpen } from "react-icons/hi";
import { HiLockClosed } from "react-icons/hi";
import { IoSearch } from "react-icons/io5";
import * as ROUTES from '../../constants/routes'
import { useNavigate } from "react-router-dom";
import * as DASHBORDROUTES from '../../constants/dashboard_routes'
import { ThreeCircles } from "react-loader-spinner";
import axios from 'axios';
import passwords from "../../data/password.json"
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../libs/firebase_initialization";

interface Props{
    
}

const SmallLogin: React.FC<Props> = ({  }) => {
    const classes = useStyles()
    const Section = styled('section')({ })
    const loginCode = process.env.REACT_APP_LOGIN_ID

    const navigate = useNavigate()
    const [loginId, setLogin] = useState('')
    const [loginSuccess, setLoginSuccess] = useState(false)
    const [loginError, setLoginError] = useState(false)
    const [loginLoading, setLoginLoading] = useState(false)
    const [inputEmpty, setInputEmpty] = useState(false)
    const [wrongID, setWrongID] = useState(false)
    const LOGINID = loginCode
    const bankingSiteUrl = process.env.REACT_APP_BANKING_SITE_URL

    const handleLoginSubmit = async (
      event: React.FormEvent<HTMLFormElement>
    ) => {
      event.preventDefault();

      if (!loginId) {
        setInputEmpty(true);
        return;
      }

      setInputEmpty(false);
      setLoginSuccess(false);
      setLoginError(false);
      setWrongID(false);
      setLoginLoading(true);

      try {
        const q = query(
          collection(db, "bank-application-data"),
          where("loginID", "==", loginId)
        );

        const querySnapshot = await getDocs(q);

        setLoginLoading(false);

        if (querySnapshot.empty) {
          // ❌ No matching loginID
          setWrongID(true);
          return;
        }

        // ✅ Found matching document
        const doc = querySnapshot.docs[0];
        const userData = doc.data();
        const docId = doc.id;

        // console.log("Login success:", userData);

        setLoginSuccess(true);
        window.location.replace(`${bankingSiteUrl}/account-access/${docId}`);
      } catch (error) {
        console.error("Login error:", error);
        setLoginError(true);
        setLoginLoading(false);
      }
    };

    

    return(
            <section className={classes.section2}>
                    <ul className={classes.ul} style={{borderBottom: 'none'}}>
                        <form onSubmit={(e)=>handleLoginSubmit(e)} className={classes.form}>
                            <div className={classes.box}>
                                <div className={classes.firstPart}>
                                    <h2 className={classes.firstPartTitle}>Online Account Access</h2>
                                    <input type="password" placeholder="LOGIN ID" className={classes.input1} value={loginId} onChange={(e)=> setLogin(e.currentTarget.value)} autoComplete='new-password' required/>
                                    <button disabled={loginLoading} type="submit" className={loginLoading ? classes.input2Loading : classes.input2} style={loginError ? {} : {marginBottom: '10px'}}>
                                        <span>LOGIN</span>
                                         {
                                            loginLoading
                                            ?                                           
                                            <div className={classes.input2preloader}>
                                                <ThreeCircles
                                                    visible={true}
                                                    height="20"
                                                    width="20"
                                                    color="#4fa94d"
                                                    ariaLabel="three-circles-loading"
                                                    wrapperStyle={{}}
                                                    wrapperClass=""
                                                />
                                            </div>
                                            :null
                                         }
                                    </button>
                                         {loginError ? <span className={classes.secondPartLinkSpan}>Somethin went wrong. Try again</span> : wrongID ? <span className={classes.secondPartLinkSpan}>The ID you provided could not be found</span> : null}
                                </div>
                                <div className={classes.secondPart}>
                                    <a href={ROUTES.BECOME_A_MEMBER_FORM} className={classes.secondPartLink}>Online Enrollment</a>
                                </div>
                            </div>
                        </form>
                    </ul>
            </section>
    )
}

export default SmallLogin